export default "__VITE_ASSET__az9TiM0g__"